import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { FooterComponent } from "../footer/footer.component";
import { HeaderComponent } from "../header/header.component";

@Component({
  selector: 'app-interbank',
  imports: [FooterComponent, HeaderComponent],
  templateUrl: './interbank.component.html',
  styleUrl: './interbank.component.css'
})
// export class InterbankComponent {} cogido borrador de abajo

export class InterbankComponent implements OnInit{
  constructor(private titleService: Title){}
  ngOnInit(): void {
    this.titleService.setTitle("Interbank") // Titulo de la página
  }
}
